<template>
  <div id="pwreset">
    <el-container>
      <el-header><i class="fas fa-lock-open"></i> パスワードリセット要求</el-header>
      <el-main>
      <el-form ref="refFrmReset" :model="frmReset" :rules="rules" label-width="150px">
      <el-form-item label="ユーザID" prop="user_id">
        <el-input placeholder="user@example.com" v-model="frmReset.user_id"></el-input>
      </el-form-item>
      <el-form-item>
        <el-alert :title="message.msg" type="error" v-if="message.err"></el-alert>
        <el-alert :title="message.msg" type="success" v-if="message.msg && !message.err"></el-alert>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">送信</el-button>
        <el-button type="default" @click="back">戻る</el-button>
      </el-form-item>
      </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  setup() {
    const router = useRouter()
    const internalInstance = getCurrentInstance()
    const refFrmReset: any = ref(null)
    const message = reactive({
      msg: '',
      err: false
    })
    const frmReset = reactive({
      user_id: ''
    })
    const rules = {
      user_id: [
        { required: true, message: 'ユーザIDを入力してください。', trigger: 'blur' },
      ],
    }
    const back = () => {
      router.back()
    }
    const onSubmit = () => {
      const api_path = internalInstance?.appContext.config.globalProperties.api_path
      refFrmReset.value.validate((valid: boolean) => {
        if(valid) {
          fetch(api_path + 'ajax/pwresetreq.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(frmReset)
          })
          .then(response => response.json())
          .then(json => {
            //console.log(json);
            if(json['result'] == 'failure') {
              message.msg = json['error'];
              message.err = true;
            }else {
              message.msg = "パスワードリセット用のリンクを送信しました。";
              message.err = false;
            }
          })
          .catch(error => console.error(error))
        }else {
          console.log('invalid')
        }
      })
    }

    return {
      refFrmReset,
      frmReset,
      message,
      rules,
      back,
      onSubmit
    }
  }
})
</script>

<style>
#pwreset {
    height: calc(100% - 69px);
    background-color: #ecf0f5;
    position: relative;
}
#pwreset .el-header {
    padding-top: 30px;
    color: #6f6f6f;
    font-size: larger;
    text-align: center;
}
#pwreset .el-container {
    width: 455px;
    margin: 0 auto;
}
#pwreset .el-form {
    text-align: left;
}
</style>